export enum Locale {
  'en-us' = 'en-us',
  // 'es-es' = 'es-es',
}

export type LocaleCode = keyof typeof Locale;
